var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_100, Card, Carousel, Typography, useBreakpoint } from '@airtel/air-design-system';
import { ImageBackground, Pressable } from 'react-native';
import { Defs, LinearGradient, Rect, Stop, Svg } from 'react-native-svg';
import { getInformationBannerWidgetStyles } from './InformationBannerWidgetStyles';
export var InformationBannerWidgetComponent = props => {
  var data = props.data,
    id = props.id,
    _onPress = props.onPress,
    onUserAction = props.onUserAction,
    carousalProps = props.carousalProps,
    style = props.style,
    restProps = __rest(props, ["data", "id", "onPress", "onUserAction", "carousalProps", "style"]);
  var isSingleCarousel = (data === null || data === void 0 ? void 0 : data.length) === 1;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var informationBannerCardStyles = getInformationBannerWidgetStyles(isSingleCarousel);
  var SingleCarousel = props => {
    var data = props.data,
      index = props.index;
    var imageUrl = data.imageUrl,
      imageStyle = data.imageStyle,
      _data$imageResizeMode = data.imageResizeMode,
      imageResizeMode = _data$imageResizeMode === void 0 ? 'cover' : _data$imageResizeMode,
      itemOnPress = data.onPress,
      title = data.title,
      titleStyle = data.titleStyle;
    return _jsx(_Fragment, {
      children: !!imageUrl && _jsxs(Pressable, Object.assign({
        style: informationBannerCardStyles.image,
        onPress: () => {
          var onPressData = itemOnPress || _onPress;
          onPressData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onPressData), {
            index,
            item: data
          }));
        }
      }, {
        children: [_jsx(ImageBackground, Object.assign({
          source: {
            uri: imageUrl
          },
          resizeMode: imageResizeMode,
          style: [informationBannerCardStyles.image, style, imageStyle]
        }, {
          children: !!title && _jsxs(Svg, Object.assign({
            height: "100%",
            width: "100%",
            style: informationBannerCardStyles.gradientOverlay
          }, {
            children: [_jsx(Defs, {
              children: _jsxs(LinearGradient, Object.assign({
                id: "gradient",
                x1: "0",
                y1: "1",
                x2: "0",
                y2: "0"
              }, {
                children: [_jsx(Stop, {
                  offset: "0%",
                  stopColor: "rgba(0, 0, 0, 0.8)",
                  stopOpacity: "1"
                }), _jsx(Stop, {
                  offset: "50.15%",
                  stopColor: "rgba(0, 0, 0, 0)",
                  stopOpacity: "0"
                })]
              }))
            }), _jsx(Rect, {
              x: "0",
              y: "0",
              width: "100%",
              height: "100%",
              fill: "url(#gradient)"
            })]
          }))
        })), !!title && _jsx(Typography, {
          text: title,
          type: isLargeScreen ? 'body-para-lg-bold' : 'body-para-xl-bold',
          color: BLACK_100,
          style: [informationBannerCardStyles.title, titleStyle]
        })]
      }))
    });
  };
  return (data === null || data === void 0 ? void 0 : data.length) ? _jsxs(Card, Object.assign({
    noPadding: true,
    showShadow: true,
    style: [informationBannerCardStyles.container, style]
  }, restProps, {
    children: [isSingleCarousel && _jsx(SingleCarousel, {
      data: data[0],
      index: 0
    }), !isSingleCarousel && _jsx(Carousel, Object.assign({
      data: data,
      renderItem: (itemProps, index) => _jsx(SingleCarousel, {
        data: itemProps,
        index: index
      })
    }, carousalProps))]
  })) : _jsx(_Fragment, {});
};
InformationBannerWidgetComponent.genericRendererKey = 'AirInformationBannerWidget';